import { connect } from "react-redux";
import ProductsGrid from "./ProductsGrid";
import { AppDispatch } from "store/store";
import Loader from "components/common/controls/Loader";
import { getProductList } from "store/slices/ProductManagementSlice";
import { Component } from "react";
import { unwrapResult } from "@reduxjs/toolkit";

interface State {
  isProductDataLoaded: boolean;
}

interface Props {
  dispatch: AppDispatch;
}

export class ManageProducts extends Component<Props, State> {
  state: Readonly<State> = {
    isProductDataLoaded: false,
  };

  componentDidMount() {
    this.setState({ isProductDataLoaded: false });

    this.props.dispatch(getProductList())
      .then(unwrapResult)
      .then(() => {
        this.setState({ isProductDataLoaded: true });
      });
  }

  render() {
    return (
      <div>
        <div className="mb-6">
          Welcome to Products List Home Page.
        </div>
        <ProductsGrid />
        <Loader isVisible={!this.state.isProductDataLoaded} />
      </div>
    );
  }
}

export default connect()(ManageProducts);
